import { t } from 'i18next';
// components
import { DragDropWithErrors, MessagesDragDropUploader } from '.';
import { ExLoader } from '@commons/EXComponentsLibrary/ExLoader';
// rsuite
import { IconButton, Panel, Uploader } from 'rsuite';
// hooks
import { useDragDropUploader } from './hooks';
// utils
import { getBackgroundColor, getBorderColor } from './utils';
import { allowedRegex } from 'utils/constants';
// style
import style from './DragDropUploader.module.css';

const NewDragDropUploader = () => {
    const {
        downloadErrorLink,
        error,
        handleUpload,
        blockerFormat,
        isFetching,
        isDragging,
        setFiles,
        handleCloseIcon,
        setBlockerFormat,
        resetErrorsWhenHaveFormatError,
        handleDragLeave,
        handlerDragEnter,
    } = useDragDropUploader();

    return (
        <div className={style['wrapper']}>
            <div className={style['container-panel-uploader-v2']}>
                <Panel
                    style={{
                        cursor: 'pointer',
                        borderRadius: 8,
                        border: '1px dashed var(--primary, #0171E6)',
                        borderColor: getBorderColor(isFetching, blockerFormat, error),
                    }}
                >
                    <div className={style['cancel-button']}>
                        {blockerFormat && (
                            <IconButton
                                size="xs"
                                className={style['icon-button-close']}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            d="M12 13.3998L7.10005 18.2998C6.91672 18.4831 6.68338 18.5748 6.40005 18.5748C6.11672 18.5748 5.88338 18.4831 5.70005 18.2998C5.51672 18.1165 5.42505 17.8831 5.42505 17.5998C5.42505 17.3165 5.51672 17.0831 5.70005 16.8998L10.6 11.9998L5.70005 7.0998C5.51672 6.91647 5.42505 6.68314 5.42505 6.3998C5.42505 6.11647 5.51672 5.88314 5.70005 5.6998C5.88338 5.51647 6.11672 5.4248 6.40005 5.4248C6.68338 5.4248 6.91672 5.51647 7.10005 5.6998L12 10.5998L16.9 5.6998C17.0834 5.51647 17.3167 5.4248 17.6 5.4248C17.8834 5.4248 18.1167 5.51647 18.3 5.6998C18.4834 5.88314 18.575 6.11647 18.575 6.3998C18.575 6.68314 18.4834 6.91647 18.3 7.0998L13.4 11.9998L18.3 16.8998C18.4834 17.0831 18.575 17.3165 18.575 17.5998C18.575 17.8831 18.4834 18.1165 18.3 18.2998C18.1167 18.4831 17.8834 18.5748 17.6 18.5748C17.3167 18.5748 17.0834 18.4831 16.9 18.2998L12 13.3998Z"
                                            fill="#40435B"
                                        />
                                    </svg>
                                }
                                onClick={handleCloseIcon}
                                disabled={isFetching}
                            />
                        )}
                    </div>
                    <Uploader
                        onDragEnter={handlerDragEnter}
                        onDragLeave={(e: React.MouseEvent) => {
                            if (!e.currentTarget.contains(e.relatedTarget as Node)) {
                                handleDragLeave(e);
                            }
                        }}
                        name="file"
                        accept={'text/plain/*'}
                        multiple={false}
                        autoUpload={true}
                        fileListVisible={false}
                        action=""
                        draggable
                        onUpload={(file) => {
                            if (allowedRegex.test(file.blobFile.type)) {
                                handleUpload(file.blobFile), setFiles(file);
                            } else {
                                resetErrorsWhenHaveFormatError();
                                setBlockerFormat(true);
                            }
                        }}
                        disabled={isFetching}
                    >
                        <div
                            style={{
                                border: 'none',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: getBackgroundColor(isFetching, blockerFormat, isDragging, error),
                            }}
                        >
                            {isFetching ? (
                                <ExLoader size="md" />
                            ) : blockerFormat ? (
                                <DragDropWithErrors
                                    error={'blockerFormat'}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="40"
                                            height="40"
                                            viewBox="0 0 40 40"
                                            fill="none"
                                        >
                                            <path
                                                d="M20 28.333C20.4723 28.333 20.8681 28.1733 21.1875 27.8538C21.507 27.5344 21.6667 27.1386 21.6667 26.6663C21.6667 26.1941 21.507 25.7983 21.1875 25.4788C20.8681 25.1594 20.4723 24.9997 20 24.9997C19.5278 24.9997 19.132 25.1594 18.8125 25.4788C18.4931 25.7983 18.3334 26.1941 18.3334 26.6663C18.3334 27.1386 18.4931 27.5344 18.8125 27.8538C19.132 28.1733 19.5278 28.333 20 28.333ZM20 21.6663C20.4723 21.6663 20.8681 21.5066 21.1875 21.1872C21.507 20.8677 21.6667 20.4719 21.6667 19.9997V13.333C21.6667 12.8608 21.507 12.465 21.1875 12.1455C20.8681 11.8261 20.4723 11.6663 20 11.6663C19.5278 11.6663 19.132 11.8261 18.8125 12.1455C18.4931 12.465 18.3334 12.8608 18.3334 13.333V19.9997C18.3334 20.4719 18.4931 20.8677 18.8125 21.1872C19.132 21.5066 19.5278 21.6663 20 21.6663ZM20 36.6663C17.6945 36.6663 15.5278 36.2288 13.5 35.3538C11.4723 34.4788 9.70837 33.2913 8.20837 31.7913C6.70837 30.2913 5.52087 28.5275 4.64587 26.4997C3.77087 24.4719 3.33337 22.3052 3.33337 19.9997C3.33337 17.6941 3.77087 15.5275 4.64587 13.4997C5.52087 11.4719 6.70837 9.70801 8.20837 8.20801C9.70837 6.70801 11.4723 5.52051 13.5 4.64551C15.5278 3.77051 17.6945 3.33301 20 3.33301C22.3056 3.33301 24.4723 3.77051 26.5 4.64551C28.5278 5.52051 30.2917 6.70801 31.7917 8.20801C33.2917 9.70801 34.4792 11.4719 35.3542 13.4997C36.2292 15.5275 36.6667 17.6941 36.6667 19.9997C36.6667 22.3052 36.2292 24.4719 35.3542 26.4997C34.4792 28.5275 33.2917 30.2913 31.7917 31.7913C30.2917 33.2913 28.5278 34.4788 26.5 35.3538C24.4723 36.2288 22.3056 36.6663 20 36.6663ZM20 33.333C23.7223 33.333 26.875 32.0413 29.4584 29.458C32.0417 26.8747 33.3334 23.7219 33.3334 19.9997C33.3334 16.2775 32.0417 13.1247 29.4584 10.5413C26.875 7.95801 23.7223 6.66634 20 6.66634C16.2778 6.66634 13.125 7.95801 10.5417 10.5413C7.95837 13.1247 6.66671 16.2775 6.66671 19.9997C6.66671 23.7219 7.95837 26.8747 10.5417 29.458C13.125 32.0413 16.2778 33.333 20 33.333Z"
                                                fill="#E22E2E"
                                            />
                                        </svg>
                                    }
                                    showButton={false}
                                    downloadErrorLink={false}
                                />
                            ) : error ? (
                                <DragDropWithErrors
                                    error={error}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="34"
                                            height="34"
                                            viewBox="0 0 34 34"
                                            fill="none"
                                        >
                                            <path
                                                d="M17 18.983L21.1084 23.0913C21.3681 23.3511 21.6987 23.4809 22.1 23.4809C22.5014 23.4809 22.832 23.3511 23.0917 23.0913C23.3514 22.8316 23.4813 22.5011 23.4813 22.0997C23.4813 21.6983 23.3514 21.3677 23.0917 21.108L18.9834 16.9997L23.0917 12.8913C23.3514 12.6316 23.4813 12.3011 23.4813 11.8997C23.4813 11.4983 23.3514 11.1677 23.0917 10.908C22.832 10.6483 22.5014 10.5184 22.1 10.5184C21.6987 10.5184 21.3681 10.6483 21.1084 10.908L17 15.0163L12.8917 10.908C12.632 10.6483 12.3014 10.5184 11.9 10.5184C11.4987 10.5184 11.1681 10.6483 10.9084 10.908C10.6487 11.1677 10.5188 11.4983 10.5188 11.8997C10.5188 12.3011 10.6487 12.6316 10.9084 12.8913L15.0167 16.9997L10.9084 21.108C10.6487 21.3677 10.5188 21.6983 10.5188 22.0997C10.5188 22.5011 10.6487 22.8316 10.9084 23.0913C11.1681 23.3511 11.4987 23.4809 11.9 23.4809C12.3014 23.4809 12.632 23.3511 12.8917 23.0913L17 18.983ZM17 31.1663C15.0403 31.1663 13.1987 30.7945 11.475 30.0507C9.75143 29.307 8.25212 28.2976 6.97712 27.0226C5.70212 25.7476 4.69275 24.2483 3.949 22.5247C3.20525 20.8011 2.83337 18.9594 2.83337 16.9997C2.83337 15.04 3.20525 13.1983 3.949 11.4747C4.69275 9.75106 5.70212 8.25176 6.97712 6.97676C8.25212 5.70176 9.75143 4.69238 11.475 3.94863C13.1987 3.20488 15.0403 2.83301 17 2.83301C18.9598 2.83301 20.8014 3.20488 22.525 3.94863C24.2487 4.69238 25.748 5.70176 27.023 6.97676C28.298 8.25176 29.3073 9.75106 30.0511 11.4747C30.7948 13.1983 31.1667 15.04 31.1667 16.9997C31.1667 18.9594 30.7948 20.8011 30.0511 22.5247C29.3073 24.2483 28.298 25.7476 27.023 27.0226C25.748 28.2976 24.2487 29.307 22.525 30.0507C20.8014 30.7945 18.9598 31.1663 17 31.1663ZM17 28.333C20.1639 28.333 22.8438 27.2351 25.0396 25.0393C27.2355 22.8434 28.3334 20.1636 28.3334 16.9997C28.3334 13.8358 27.2355 11.1559 25.0396 8.96009C22.8438 6.76426 20.1639 5.66634 17 5.66634C13.8362 5.66634 11.1563 6.76426 8.96046 8.96009C6.76462 11.1559 5.66671 13.8358 5.66671 16.9997C5.66671 20.1636 6.76462 22.8434 8.96046 25.0393C11.1563 27.2351 13.8362 28.333 17 28.333Z"
                                                fill="#E22E2E"
                                            />
                                        </svg>
                                    }
                                    showButton={true}
                                    downloadErrorLink={downloadErrorLink}
                                />
                            ) : (
                                <MessagesDragDropUploader
                                    text={
                                        'Arrastrá y soltá tu archivo para deshabilitar puntos de venta de forma masiva.'
                                    }
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="40"
                                            height="40"
                                            viewBox="0 0 40 40"
                                            fill="none"
                                        >
                                            <path
                                                d="M10.8333 33.3337C8.30551 33.3337 6.14579 32.4587 4.35413 30.7087C2.56246 28.9587 1.66663 26.8198 1.66663 24.292C1.66663 22.1253 2.3194 20.1948 3.62496 18.5003C4.93051 16.8059 6.63885 15.7225 8.74996 15.2503C9.4444 12.6948 10.8333 10.6253 12.9166 9.04199C15 7.45866 17.3611 6.66699 20 6.66699C23.25 6.66699 26.0069 7.79894 28.2708 10.0628C30.5347 12.3267 31.6666 15.0837 31.6666 18.3337C33.5833 18.5559 35.1736 19.3823 36.4375 20.8128C37.7013 22.2434 38.3333 23.917 38.3333 25.8337C38.3333 27.917 37.6041 29.6878 36.1458 31.1462C34.6875 32.6045 32.9166 33.3337 30.8333 33.3337H21.6666V21.417L23.1666 22.8753C23.4722 23.1809 23.8541 23.3337 24.3125 23.3337C24.7708 23.3337 25.1666 23.167 25.5 22.8337C25.8055 22.5281 25.9583 22.1392 25.9583 21.667C25.9583 21.1948 25.8055 20.8059 25.5 20.5003L21.1666 16.167C20.8333 15.8337 20.4444 15.667 20 15.667C19.5555 15.667 19.1666 15.8337 18.8333 16.167L14.5 20.5003C14.1944 20.8059 14.0347 21.1878 14.0208 21.6462C14.0069 22.1045 14.1666 22.5003 14.5 22.8337C14.8055 23.1392 15.1875 23.2989 15.6458 23.3128C16.1041 23.3267 16.5 23.1809 16.8333 22.8753L18.3333 21.417V33.3337H10.8333Z"
                                                fill="#0171E6"
                                            />
                                        </svg>
                                    }
                                    flag={true}
                                />
                            )}
                        </div>
                    </Uploader>
                </Panel>
            </div>
        </div>
    );
};

export default NewDragDropUploader;
